export default "__VITE_ASSET__C12nm_YF__"